// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__3HZl9","btnPagination":"Pagination_btnPagination__3VZPi"};